export default __webpack_public_path__ + "static/media/ClosedSystems.44480c9b.jpeg";